module.exports = __webpack_public_path__ + "images/application/approval-sending-95c48d42.svg";